/** User-facing copy when `app-mode:set-mode` is rejected. */
export function appModeBlockedLabel(result) {
    switch (result.reason) {
        case 'active-local-build':
            return 'Stop the current build before switching modes.';
        case 'active-local-preview':
            return 'Stop the current preview before switching modes.';
        case 'cloud-disabled':
            return 'Cloud Foundry is unavailable for this build.';
        case 'cloud-session-clearing':
            return 'Cloud Foundry is signing out. Try again in a moment.';
        case 'persistence-failed':
            return result.message ?? 'Could not save Foundry mode. Try again.';
        case 'window-recreation-failed':
            return result.message ?? 'Could not switch Foundry modes. Try again.';
    }
}
//# sourceMappingURL=app-mode-blocked-label.js.map